<template>
  <div class="grid grid-cols-3 px-1 py-2 py-2 border-b-1 border-color">
    <div></div>
    <div class="flex justify-center items-center">
      <div class="text-start capitalize">{{ exBuy }}</div>
    </div>
    <div class="flex justify-end items-center">
      <div class="text-start capitalize">{{ exSell }}</div>
    </div>
  </div>
  <div class="grid grid-cols-3 px-1 py-2 border-b-1 border-color">
    <div class="text-start">{{ $t('modal.createSwapOrders.limitQuote') }}</div>
    <div class="flex justify-center items-center">
      <Skeleton v-if="limitsLoading" width="40px"></Skeleton>
      <span v-else>{{ limits?.buy?.amount_max ? numberWithCommas(limits?.buy?.amount_max) : "—" }}</span>
    </div>
    <div class="flex justify-end items-center">
      <Skeleton v-if="limitsLoading" width="40px"></Skeleton>
      <span v-else>{{ limits?.sell?.amount_max ? numberWithCommas(limits?.sell?.amount_max) : "—" }}</span>
    </div>
  </div>
  <div class="grid grid-cols-3 px-1 py-2">
    <div class="text-start">{{ $t('modal.createSwapOrders.limitUsdt') }}</div>
    <div class="flex justify-center items-center">
      <Skeleton v-if="limitsLoading" width="40px"></Skeleton>
      <span v-else>{{ limits?.buy?.cost_max ? numberWithCommas(limits?.buy?.cost_max) : "—" }}</span>
    </div>
    <div class="flex justify-end items-center">
      <Skeleton v-if="limitsLoading" width="40px"></Skeleton>
      <span v-else>{{ limits?.sell?.cost_max ? numberWithCommas(limits?.sell?.cost_max) : "—" }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { numberWithCommas } from "@/utils";
import Skeleton from 'primevue/skeleton';

defineProps<{
  limitsLoading: boolean | undefined,
  limits: any, // eslint-disable-line
  exBuy: string | null,
  exSell: string | null,
  singleMode?: boolean
}>()
</script>
